import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Upload, Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder, api } from 'api';
import styles from './ScheduleUploadFile.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import { ReactComponent as CloseIcon } from '@/images/icons/edm/remove-icon.svg';
import { cloneDeep } from 'lodash';
import { getIn18Text } from 'api';
const systemApi = api.getSystemApi();
const httpApi = apiHolder.api.getDataTransApi();
const limitNum = 4;
const ScheduleUploadFile = props => {
    var _a, _b;
    const { value, onChange, disabled } = props;
    const [fileArray, setFileArray] = useState([]);
    useEffect(() => {
        if (value && value.length) {
            console.log(4444, value);
            const initValue = cloneDeep(value);
            setFileArray(initValue.map(f => {
                var _a;
                if (!f.status) {
                    f.status = 'done';
                    f.accountAttachmentAccountId = f.accountAttachmentAccountId || ((_a = f === null || f === void 0 ? void 0 : f.belonger) === null || _a === void 0 ? void 0 : _a.accountId);
                }
                return f;
            }));
        }
        else {
            setFileArray([]);
        }
    }, [value]);
    const uploadUrl = systemApi.getUrl('scheduleUploadFile');
    const param = { uid: (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id };
    const isCorpMail = systemApi.getIsCorpMailMode();
    if (isCorpMail) {
        param.sid = (_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.sessionId;
    }
    const actionUrl = httpApi.buildUrl(uploadUrl, param);
    const beforeUpload = (file, fileList) => {
        if (fileArray.length >= limitNum) {
            message.error({
                content: getIn18Text('schedule_upload_file_num'),
                duration: 2,
            });
            return false;
        }
        if (file.size > 50 * 1024 * 1024) {
            message.error({
                content: getIn18Text('schedule_upload_file_limit'),
                duration: 2,
            });
            return false;
        }
        if (fileList.length > limitNum) {
            const index = fileList.indexOf(file);
            if (index === limitNum) {
                message.error({
                    content: getIn18Text('schedule_upload_file_num'),
                    duration: 2,
                });
            }
            if (index >= limitNum) {
                return false;
            }
        }
        return Promise.resolve(file);
    };
    const handleChange = info => {
        let newFileList = [...info.fileList];
        newFileList = newFileList.filter(f => !!f.status);
        newFileList = newFileList.map(file => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const f = cloneDeep(file);
            if (f.status === 'done') {
                f.accountAttachmentId = ((_b = (_a = f.response) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.accountAttachmentId) || f.accountAttachmentId || '';
                f.belonger = ((_d = (_c = f.response) === null || _c === void 0 ? void 0 : _c.data[0]) === null || _d === void 0 ? void 0 : _d.belonger) || f.belonger || {};
                f.accountAttachmentAccountId = ((_g = (_f = (_e = f.response) === null || _e === void 0 ? void 0 : _e.data[0]) === null || _f === void 0 ? void 0 : _f.belonger) === null || _g === void 0 ? void 0 : _g.accountId) || f.accountAttachmentAccountId || ((_h = f === null || f === void 0 ? void 0 : f.belonger) === null || _h === void 0 ? void 0 : _h.accountId) || '';
                f.progress = 100;
            }
            else if (f.status === 'uploading') {
                f.progress = 99;
            }
            return f;
        });
        onChange && onChange(newFileList);
    };
    const propsUpload = {
        action: actionUrl,
        onChange: handleChange,
        multiple: true,
        maxCount: 4,
        beforeUpload,
        showUploadList: false,
        fileList: fileArray,
    };
    const removeFile = (index) => {
        if (fileArray && index >= fileArray.length) {
            return;
        }
        const fileArrayCp = cloneDeep(fileArray) || [];
        fileArrayCp === null || fileArrayCp === void 0 ? void 0 : fileArrayCp.splice(index, 1);
        onChange && onChange(fileArrayCp);
    };
    const renderFileList = () => {
        {
            return fileArray === null || fileArray === void 0 ? void 0 : fileArray.map((f, idx) => {
                var _a, _b, _c;
                let type = 'other';
                if ((_a = f.name) === null || _a === void 0 ? void 0 : _a.includes('.')) {
                    type = ((_b = f.name) === null || _b === void 0 ? void 0 : _b.substring(((_c = f.name) === null || _c === void 0 ? void 0 : _c.lastIndexOf('.')) + 1)) || 'other';
                }
                return (React.createElement("div", { className: styles.fileItem, key: idx },
                    React.createElement("div", { className: styles.attachmentLogo },
                        React.createElement(IconCard, { style: { width: '20px', height: '20px' }, type: type })),
                    React.createElement("div", { className: styles.attachmentName, title: f.name || getIn18Text('WEIMINGMING') }, f.name || getIn18Text('WEIMINGMING')),
                    React.createElement("div", { className: styles.progressBox },
                        React.createElement("div", { className: classnames(styles.progress, {
                                [styles.progressDone]: f.status === 'done' || +f.progress === 100,
                                [styles.progressing]: f.status === 'uploading' || +f.progress < 100,
                            }) })),
                    !disabled && React.createElement(CloseIcon, { onClick: () => removeFile(idx), className: styles.closeIcon })));
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.btnOut },
            React.createElement(Upload, Object.assign({}, propsUpload, { className: styles.btn }),
                React.createElement(Button, { disabled: disabled }, getIn18Text('TIANJIAFUJIAN'))),
            React.createElement("div", { className: styles.tip }, getIn18Text('DANGEFUJIANDAXBCG50M，ZDKSC4GFJ'))),
        React.createElement("div", { className: styles.fileList }, renderFileList())));
};
export default ScheduleUploadFile;
